"use client";
import React from "react";
import { useGeoLocation } from "@/lib/hooks/useGeoLocation";
import { Section } from "./Section";
import { Typography } from "./Typography";
import { NewButton } from "./NewButton";
import Link from "next/link";
import Image from "next/image";
import { env } from "@/lib/environment";

const imgBaseUrl = `${env.NEXT_PUBLIC_CDN_URL}/images/home`;


export function AmazonStickUS() {
  const { geoData, isLoading } = useGeoLocation();
  // Don't render anything while loading or if not US
  if (isLoading || !geoData || geoData.countryCode !== "US") {
    return null;
  }
  return       <Section variant="default">
  <div className="text-center border bg-white border-[#E2E2E2] rounded-2xl py-5 px-5 md:py-[60px] md:px-12 mx-auto mb-10">
    <div className="grid grid-cols-1 md:grid-cols-2 place-content-center gap-6 md:gap-6 w-full items-center">
    <div className="flex flex-col gap-6 text-center md:text-left">
      <Typography variant="h2" as="h2">
        Amazon Signage Stick - Professional Signage Made Simple
      </Typography>
      <Typography variant="body" as="p" className="w-full mx-auto">
        Pickcel digital signage solution is compatible with TVs, media players, and 50+ devices — Android, Windows, LG webOS, Tizen, Fire TV, ChromeOS, and more.
      </Typography>
      <div className="flex flex-col items-center md:flex-row gap-7 mt-5">
        <a href="https://www.amazon.com/dp/B0D4FCG9MX/ref=pmkt_cmspickcel_web" target="_blank" rel="noopener noreferrer" data-mixpanel-id="other-start-free-trial">
          <NewButton
            variant="primary"
            size="lg"
            arrow="grow"
            asChild
            className="text-base md:text-lg w-auto"
          >
            Buy on Amazon
          </NewButton>
        </a>
        <Link href="/digital-signage-player/amazon-signage-stick" target="_self" data-mixpanel-id="other-book-a-demo">
          <NewButton
            variant="outlinePrimary"
            size="lg"
            asChild
            className="text-base md:text-lg"
          >
            Learn More
          </NewButton>
        </Link>
      </div>

    </div>
    <div className="flex flex-col text-center md:text-left">
      <Image src={imgBaseUrl + "/amazon-signage-stick.RDqSAcArT2ve.webp"} alt="Amazon Signage Stick" title="Amazon Signage Stick" width={395} height={288} className="w-full" />
    </div>
    </div>
  </div>
</Section>;
}